import React from "react";

export const Mark = ({ size = 34, className = "" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#0F172A" />
    <path
      d="M15 45 L28 32 L38 40 L50 22"
      fill="none"
      stroke="#F8FAFC"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="15" cy="45" r="4.2" fill="#F8FAFC" />
    <circle cx="50" cy="22" r="6" fill="#2563EB" stroke="#0F172A" strokeWidth="2.5" />
  </svg>
);

export const Logo = ({ size = 34, showWord = true, tone = "ink", className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <Mark size={size} />
    {showWord && (
      <span
        className="font-display font-extrabold tracking-tight leading-none"
        style={{
          fontSize: size * 0.62,
          color: tone === "light" ? "#F8FAFC" : "#0F172A",
        }}
      >
        decidova
      </span>
    )}
  </div>
);
